import { render } from "./Widget10.vue?vue&type=template&id=2ccff52a&scoped=true"
import script from "./Widget10.vue?vue&type=script&lang=js"
export * from "./Widget10.vue?vue&type=script&lang=js"

import "./Widget10.vue?vue&type=style&index=0&id=2ccff52a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccff52a"]])

export default __exports__